export const NAV_ITEM_ANIM_INTERVAL = 600;
